import '../../common/bn-property';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class FarmAddress extends LitEntity {
  static get properties() {
    return {
      includeMapLinks: { type: Boolean, attribute: 'include-map-links' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      a {
        white-space: nowrap;
      }
      .map-links {
        font-size: .9em;
      }
      .divider {
        color: var(--gray-60);
        margin: 0 .6em;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html``;
    }
    const { address, latitude, longitude } = this.entity.properties;
    if (!latitude || !longitude) {
      return html``;
    }
    const mapsHref = `https://www.google.com/maps/dir/?api=1&travelmode=driving&dir_action=navigate&destination=${latitude},${longitude}`;
    return html`
      ${address}
      ${renderIf(this.includeMapLinks, () => html`
        <span class="map-links">
          <span class="divider">|</span>
          <a href="geo:${latitude},${longitude}">${latitude},${longitude}</a>
          <span class="divider">|</span>
          <a target="_blank" href="${mapsHref}">
            Google Maps
            <bn-icon name="far fa-external-link"></bn-icon>
          </a>
        </span>
      `)}
    `;
  }
}

customElements.define('farm-address', FarmAddress);
